// Keys for query params
export const QUERY_CLIENT_ID = 'client_id';
export const QUERY_LANGUAGE = 'language';
export const QUERY_REDIRECT_URI = 'redirect_uri';
export const QUERY_RESPONSE_TYPE = 'response_type';
export const QUERY_STATE = 'state';
export const RESPONSE_TYPE_CODE = 'code';
export const LOGIN_POPUP_HEIGHT = '689';
export const LOGIN_POPUP_WIDTH_MOBILE = '328';
export const LOGIN_POPUP_WIDTH_TABLET = '534';
export const LOGIN_POPUP_WIDTH_DESKTOP = '432';
